import React from 'react'

const Logo = ({ w, h }) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width={w} height={h} viewBox="0 0 370.000000 155.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,155.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M344 1137 c-47 -41 -44 -52 96 -275 l34 -53 -32 -29 c-46 -41 -43
-76 13 -160 56 -85 99 -117 200 -153 52 -18 88 -37 102 -55 16 -20 24 -24 33
-16 9 9 9 17 1 32 -20 37 -42 52 -111 73 -90 27 -142 65 -191 142 -43 67 -46
92 -12 114 21 14 23 12 59 -41 20 -31 41 -56 46 -56 29 0 6 47 -101 217 -67
104 -121 199 -121 211 0 24 36 40 54 23 6 -7 52 -76 102 -154 50 -78 98 -143
107 -145 25 -5 21 18 -14 72 -34 54 -34 79 -2 84 16 2 28 -7 48 -42 32 -55 52
-73 66 -59 7 7 0 27 -22 61 -57 93 -6 118 55 27 20 -30 40 -55 46 -55 21 0 20
22 -3 62 -27 47 -26 68 3 68 25 0 114 -145 139 -225 10 -33 22 -108 26 -168 7
-104 15 -131 31 -105 12 19 4 195 -12 256 -17 64 -84 196 -127 247 -31 38 -74
47 -96 21 -8 -9 -24 -12 -50 -9 -30 4 -43 1 -60 -16 -12 -12 -34 -21 -50 -21
-17 0 -33 -4 -36 -10 -12 -20 -25 -9 -71 62 -26 40 -54 78 -63 85 -25 19 -57
15 -87 -10z"/>
                <path d="M27 1033 c35 -5 35 -6 80 -178 20 -80 31 -93 55 -65 22 28 88 28 106
0 15 -25 44 -15 40 14 -3 19 -10 21 -90 24 -69 2 -88 6 -88 17 0 12 17 15 83
15 l84 0 11 51 c19 83 26 78 -105 81 -114 3 -118 4 -121 26 -3 19 -9 22 -45
20 -36 -1 -38 -2 -10 -5z m123 -233 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3
6 -1 10 4 10 6 0 11 -4 11 -10z m150 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                <path d="M1174 916 c-43 -19 -64 -53 -64 -102 0 -54 26 -87 100 -124 65 -33
82 -60 54 -91 -21 -23 -77 -25 -114 -4 -38 22 -50 18 -50 -15 0 -37 33 -61 94
-67 94 -11 166 42 166 121 0 56 -26 89 -100 126 -32 16 -61 38 -64 48 -9 29 3
51 32 59 23 5 36 2 95 -22 14 -6 17 -2 17 24 0 27 -5 34 -35 47 -43 17 -90 17
-131 0z"/>
                <path d="M1925 918 c-43 -15 -94 -67 -106 -109 -18 -58 -8 -192 17 -225 42
-57 69 -69 152 -69 96 0 140 23 174 93 28 58 31 179 6 227 -43 82 -146 117
-243 83z m120 -68 c38 -14 58 -70 53 -148 -4 -58 -8 -68 -36 -93 -34 -31 -74
-37 -115 -18 -33 15 -48 44 -54 104 -13 121 56 191 152 155z"/>
                <path d="M1425 908 c-3 -8 -4 -97 -3 -198 l3 -185 40 0 40 0 3 83 3 82 74 0
75 0 0 -86 0 -85 38 3 37 3 0 195 0 195 -37 3 -38 3 0 -80 0 -81 -75 0 -74 0
-3 78 -3 77 -38 3 c-24 2 -39 -1 -42 -10z"/>
                <path d="M2268 914 c-5 -4 -8 -95 -8 -201 l0 -194 38 3 37 3 3 68 3 67 37 1
c91 1 152 54 152 130 0 91 -39 121 -165 127 -49 2 -93 1 -97 -4z m149 -62 c17
-11 33 -59 26 -79 -12 -35 -36 -53 -70 -53 l-33 0 0 70 0 70 33 0 c17 0 37 -4
44 -8z"/>
                <path d="M2600 720 l0 -201 108 3 107 3 0 30 0 30 -67 3 -68 3 -2 162 -3 162
-37 3 -38 3 0 -201z"/>
                <path d="M2865 908 c-3 -8 -4 -97 -3 -198 l3 -185 40 0 40 0 0 195 0 195 -38
3 c-24 2 -39 -1 -42 -10z"/>
                <path d="M3040 900 c-7 -12 -9 -86 -8 -197 l3 -178 35 0 35 0 3 150 3 150 73
-144 c41 -79 80 -147 87 -152 8 -5 31 -9 51 -9 49 0 49 3 46 220 l-3 175 -35
0 -35 0 -3 -135 -3 -135 -65 125 c-36 68 -70 130 -76 137 -6 7 -30 13 -54 13
-33 0 -46 -5 -54 -20z"/>
                <path d="M1400 255 l0 -155 25 0 c24 0 25 3 25 61 0 87 26 123 71 99 16 -9 19
-22 19 -85 l0 -75 31 0 32 0 -5 85 c-5 103 -22 129 -78 122 -19 -2 -43 -7 -52
-11 -16 -7 -18 -1 -18 53 0 58 -1 61 -25 61 l-25 0 0 -155z"/>
                <path d="M2160 255 l0 -155 30 0 30 0 0 75 c0 64 3 76 20 85 14 8 26 8 40 0
17 -9 20 -21 20 -85 l0 -75 30 0 30 0 0 76 c0 72 -10 111 -34 126 -16 11 -64
10 -87 -2 -18 -10 -19 -7 -19 50 l0 60 -30 0 -30 0 0 -155z"/>
                <path d="M1242 294 c-25 -17 -30 -65 -8 -83 7 -6 31 -17 52 -25 21 -7 39 -19
39 -27 0 -19 -54 -24 -61 -6 -5 15 -40 12 -49 -4 -12 -18 39 -49 80 -49 53 0
85 23 85 60 0 36 -20 57 -70 70 -24 6 -40 17 -40 25 0 18 33 19 60 3 15 -10
22 -10 32 0 9 9 7 16 -7 32 -22 24 -81 27 -113 4z"/>
                <path d="M1664 300 c-34 -13 -54 -50 -54 -98 0 -35 6 -49 30 -74 29 -28 35
-30 87 -26 46 4 61 10 80 32 25 29 31 92 13 127 -22 41 -102 61 -156 39z m91
-55 c31 -30 31 -47 2 -81 -19 -22 -29 -26 -51 -20 -62 16 -52 124 12 126 7 0
24 -11 37 -25z"/>
                <path d="M1850 155 l0 -155 25 0 c24 0 25 3 25 60 0 55 10 75 25 50 3 -5 24
-10 46 -10 29 0 47 7 64 24 82 82 -8 228 -108 175 -16 -9 -22 -9 -25 0 -2 6
-15 11 -28 11 l-24 0 0 -155z m151 81 c15 -32 4 -73 -22 -87 -48 -25 -95 33
-70 87 15 35 77 35 92 0z"/>
                <path d="M2423 300 c-58 -23 -69 -134 -18 -177 36 -32 104 -31 141 0 28 24 26
47 -3 47 -9 0 -25 -8 -35 -17 -23 -20 -71 -8 -76 20 -3 15 6 17 74 17 l77 0
-6 38 c-11 68 -82 101 -154 72z m85 -42 c21 -21 13 -28 -33 -28 -25 0 -45 4
-45 8 0 15 24 32 45 32 12 0 26 -5 33 -12z"/>
                <path d="M2600 205 l0 -105 25 0 c24 0 25 2 25 63 0 49 4 68 18 80 35 32 47
22 44 -33 -4 -44 -1 -53 26 -80 42 -41 110 -43 149 -4 25 25 25 27 8 36 -13 8
-25 6 -47 -6 -32 -20 -63 -14 -78 15 -10 18 -7 19 64 19 41 0 77 4 80 8 10 16
-15 81 -37 97 -31 22 -99 19 -131 -6 l-26 -20 0 20 c0 25 -17 27 -48 5 -20
-14 -22 -14 -22 0 0 10 -9 16 -25 16 l-25 0 0 -105z m248 53 c21 -21 13 -28
-33 -28 -32 0 -45 4 -45 14 0 25 57 35 78 14z"/>
            </g>
        </svg>

    )
}

export default Logo
